import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineRainbowIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M5 12a1.0002 1.0002 0 0 0-.7071 1.7071C4.4804 13.8946 4.7348 14 5 14a5 5 0 0 1 5 5 1.0001 1.0001 0 0 0 2 0 6.9998 6.9998 0 0 0-7-7Zm0-8a1 1 0 0 0 0 2 13 13 0 0 1 13 13 1.0001 1.0001 0 0 0 2 0A15 15 0 0 0 5 4Zm0 4a1 1 0 0 0 0 2 9.0002 9.0002 0 0 1 9 9 1.0001 1.0001 0 0 0 2 0A11 11 0 0 0 5 8Z"/>
  </SvgIcon>
}

export default LineRainbowIcon
